import Window from "./entities/Window";
import Door from "./entities/Door";
import FrenchDoor from "./entities/FrenchDoor";

const Form = ({ handleTraitChange, trait, yurtTrait }) => {

  const handleWindowCheckBox = (e, v) => {
    const output = {
      target: {
        form: {
          id: trait.id,
        },
        name: e,
        value: v,
        parentElement: {
          id: null,
        },
      },
    };

    handleTraitChange(output);
  };

  return (
    <div>
      <form autoComplete="off" className="mb-5" id={trait.id}>
        {/* windows */}

        <div className="trait-section">
          <p>Windows</p>
          <div className="mb-2 window-check-box">
            <div
              onClick={() => handleWindowCheckBox("windows", 0)}
              style={{
                backgroundColor: trait.windows === 0 ? "black" : "transparent",
                color: trait.windows === 0 ? "white" : "black",
              }}
            >
              0
            </div>
            <div
              onClick={() => handleWindowCheckBox("windows", 1)}
              style={{
                backgroundColor: trait.windows === 1 ? "black" : "transparent",
                color: trait.windows === 1 ? "white" : "black",
              }}
            >
              1
            </div>
            <div
              onClick={() => handleWindowCheckBox("windows", 2)}
              style={{
                backgroundColor: trait.windows === 2 ? "black" : "transparent",
                color: trait.windows === 2 ? "white" : "black",
              }}
            >
              2
            </div>
          </div>

          <div
            style={{
              display: !trait.windows ? "none" : "flex",
              background: "white",
            }}
            className="row my-3 py-2"
          >
            <Window
              handleTraitChange={handleTraitChange}
              trait={trait}
              window={trait.window1}
              number={'Top'}
              windowID={"window1"}
              sectionColor="#ADD8E6"
            />
          </div>

          <div
            className="py-2 my-1 row"
            style={{
              display: trait.windows <= 1 ? "none" : "flex",
              background: "white",
            }}
          >
            <Window
              handleTraitChange={handleTraitChange}
              trait={trait}
              window={trait.window2}
              number={'Bottom'}
              windowID={"window2"}
              sectionColor="#dfc3eb"
            />
          </div>
        </div>
        <div className="trait-section">
          <Door trait={trait} handleTraitChange={handleTraitChange} />
        </div>
        <div className="trait-section">
          <FrenchDoor trait={trait} handleTraitChange={handleTraitChange} />
        </div>

        <br />
        <div className="trait-section">
          <p>Notes</p>
          <textarea
            className="form-control"
            style={{ height: "200px" }}
            name="notes"
            onChange={(e) => handleTraitChange(e)}
            defaultValue={trait.notes}
          ></textarea>
        </div>
      </form>
    </div>
  );
};

export default Form;
